import * as React from 'react';
import * as PropTypes from 'prop-types';
import { useState, useEffect, useRef } from 'react';
import {
  Wrapper,
  MonthYear,
  Action,
  Title,
  MonthDays,
  Day
} from './styled';
import { MONTHS } from './../../constants';
import { WeekDays } from './../WeekDays';
import { DayType } from '../../types/Day';
import { usePosition } from '../../hooks/usePosition';
import {
  getPrevDate,
  getNextDate,
  getDaysByMonth
} from './../../utils';
import { formatDate } from './../../../../utils/helpers';

interface Props {
  month: number;
  year: number;
  min?: string;
  max?: string;
  selected: number;
  onClick?: Function;
}

export const Calendar: React.FC<Props> = ({
  month,
  year,
  min,
  max,
  selected,
  onClick
}) => {

  const [ calendar, setCalendar ] = useState({ month, year });
  const daysByMonth = getDaysByMonth(calendar.month, calendar.year, formatDate(min), formatDate(max));

  useEffect(() => {
    setCalendar({ month, year });
  }, [ month, year ]);

  const handleClickPrevMonth = () => {
    setCalendar(getPrevDate(calendar));
  };

  const handleClickNextMonth = () => {
    setCalendar(getNextDate(calendar));
  };

  const handleClick = (day: DayType, month: number, year: number) => {
    onClick && onClick(day, month, year);
  }

  const ref = useRef(null);
  const pos = usePosition(ref);

  return(
    <Wrapper ref={ref} pos={pos}>
      <MonthYear>
        <Action name="chevron-left" onClick={handleClickPrevMonth} />
        <Title>{MONTHS[calendar.month]} {calendar.year}</Title>
        <Action name="chevron-right" onClick={handleClickNextMonth} />
      </MonthYear>
      <WeekDays />
      <MonthDays>
        { daysByMonth.map((day, index) => {
          const isSelected = new Date(year, month, selected).getTime() == new Date(calendar.year, calendar.month, day.dayMonth).getTime();
          return(
            <Day
              key={index}
              selected={(!day.disabled && isSelected)}
              disabled={day.disabled || !day.dayMonth}
              onClick={() => handleClick(day, calendar.month, calendar.year)}
            >
              {day.dayMonth}
            </Day>
          );
        }) }
      </MonthDays>
    </Wrapper>
  );
};

Calendar.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  selected: PropTypes.number.isRequired,
  onClick: PropTypes.func
}

Calendar.displayName = 'Calendar';
